module.exports = __webpack_public_path__ + "static/media/share.3e939755.svg";